import SolelyTable from './solely-table/'
import SolelyCard from './solely-card/'
import {
  SlsInput,
  SlsTextarea,
  SlsSelect,
  upload,
  VueEditor,
  SlsCheckbox,
  SlsDatetime,
  SlsCascader,
  SlsDateTimeRange,
  BaiduMap,
  TinymceEditor,
  SlsTimeRange,
  SlsDate,
  SlsDateMonth,
  Rate,
  QiUpload,
  TUpload

 } from './solely-fields/index.js'

 
import solelyEcharts from './echarts/solely-echarts.vue'


export default{
  SolelyTable,
  SlsInput,
  SlsTextarea,
  SlsSelect,
  upload,
  VueEditor,
  SlsCheckbox,
  SlsDatetime,
  SlsCascader,
  SlsDateTimeRange,
  BaiduMap,
  SolelyCard,
  TinymceEditor,
  solelyEcharts,
  SlsTimeRange,
  SlsDate,
  SlsDateMonth,
  Rate,
  QiUpload,
  TUpload
}



// WEBPACK FOOTER //
// ./src/components/index.js